import {
  ScmAuth,
  scmAuthApiRef,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import {
    AnyApiFactory,
    configApiRef,
    createApiFactory, discoveryApiRef, oauthRequestApiRef,
} from '@backstage/core-plugin-api';
import {
  pequiGithubActionsApiRef,
  PequiGithubActionsClient,
} from '@internal/plugin-pequi-github-actions';
import {
    ApiRef,
    BackstageIdentityApi, createApiRef,
    OpenIdConnectApi,
    ProfileInfoApi, SessionApi,
} from '@backstage/core-plugin-api';
import {OAuth2} from "@backstage/core-app-api";


export const oidcAuthApiRef: ApiRef<
    OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
> = createApiRef({
    id: 'keycloak',
});

export const apis: AnyApiFactory[] = [
    createApiFactory({
        api: oidcAuthApiRef,
        deps: {
            discoveryApi: discoveryApiRef,
            oauthRequestApi: oauthRequestApiRef,
            configApi: configApiRef,
        },
        factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
            OAuth2.create({
                configApi,
                discoveryApi,
                oauthRequestApi,
                provider: {
                    id: 'keycloak',
                    title: 'Log in with keycloak',
                    icon: () => null,
                },
                environment: configApi.getOptionalString('auth.environment'),
                defaultScopes: ['openid', 'profile', 'email'],

                popupOptions: {
                    // optional, used to customize login in popup size
                    size: {
                        fullscreen: true,
                    },
                    /**
                     * or specify popup width and height
                     * size: {
                     width: 1000,
                     height: 1000,
                     }
                     */
                },
            }),
    }),

  // Registro do ScmIntegrationsApi
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),

  // Registro do ScmAuth
  ScmAuth.createDefaultApiFactory(),

  // Configuração para GitHub Actions API
  createApiFactory({
    api: pequiGithubActionsApiRef,
    deps: { configApi: configApiRef, scmAuthApi: scmAuthApiRef },
    factory: ({ configApi, scmAuthApi }) =>
      new PequiGithubActionsClient({ configApi, scmAuthApi }),
  }),
];
